// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1F2I4V0q3S-tQu91S7vWaw","avatar":"m-ihwvHsluJlwfTDRLBWO","info":"_1DN67N1YhQaEBcnU9GiKs7"};